import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class CustomerManagementService {
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  addCustomer(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'Customers/AddCustomer',
      data
    );
  }

  getCustomers(): Observable<any[]> {
    return this.http.get<any[]>(
      this.O3CoreApiUrl + 'Customers/GetAllCustomers'
    );
  }

  deleteCustomerProfile(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'Customers/DeleteCustomerProfile',
      data
    );
  }

  saveCustomerUploads(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'Customers/SaveCustomerUploads',
      data
    );
  }

  updateCustomerUploads(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'Customers/UpdateCustomerUploads',
      data
    );
  }

  getAllCustomerFileUploads(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'Customers/GetAllCustomerFileUploads',
      data
    );
  }

  getAllCustomerFileUploadsForCustomers(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'Customers/GetAllCustomerFileUploadsForCustomers',
      data
    );
  }

  deleteCustomer(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'Customers/DeleteCustomer',
      data
    );
  }
  updateCustomer(data: any): any {
    return this.http.put<any>(
      this.O3CoreApiUrl + 'Customers/UpdateCustomer',
      data
    );
  }

  getCountries(): Observable<any> {
    return this.http.get<any>(this.O3CoreApiUrl + 'Country/GetAllCountries');
  }
  getCities(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'City/GetAllCitiesByCountryId',
      data
    );
  }
  getCustomerById(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'Customers/GetCustomerById',
      data
    );
  }

  addUserByCustomer(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/AddCustomerUser',
      data
    );
  }

  getUserList(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/GetAllCustomerUser',
      data
    );
  }
  deleteUser(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/deleteCustomerUser',
      data
    );
  }
  getUserById(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/getCustomerUserById',
      data
    );
  }

  updateUser(data: any): any {
    return this.http.put<any>(
      this.O3CoreApiUrl + 'CustomerUser/updateCustomerUser',
      data
    );
  }

  customerLogin(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/CustomerLogin',
      data
    );
  }

  getCCRCustomerUsers(): Observable<any> {
    return this.http.get<any>(
      this.O3CoreApiUrl + 'CustomerUser/GetCCRCustomerUsers/');
  }

  getCCRUserCustomersByUserId(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/GetCCRUserCustomersByUserId',
      data
    );
  }

  getAttachedCCRUserCustomersByUserId(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/GetAttachedCCRUserCustomersByUserId',
      data
    );
  }
  getPlantsByCustomerId(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/GetPlantsByCustomerId',
      data
    );
  }

  getProductsMasterByPlantId(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/getProductsMasterByPlantId',
      data
    );
  }
  addProductsToUser(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/AddProductsToUser',
      data
    );
  }

  getProductsDetail(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/GetProductsDetail',
      data
    );
  }
  getAttachedPlantsByCustomerId(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/GetAttachedPlantsByCustomerId',
      data
    );
  }
  removeCustomerPlantProductAccess(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'CustomerUser/RemoveCustomerPlantProductAccess',
      data
    );
  }
  uploaderBulkCustomers(data: any): Observable<any> {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'Customer/UploadBulkCustomers',
      data
    );
  }

  getAllPlantsInGroupByGroupCode(groupCode: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Customers/GetAllPlantsInGroupByGroupCode', groupCode);
  }

  getAllEmployees(groupCode: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Customers/getAllEmployees', groupCode);
  }

}
